import { render, staticRenderFns } from "./XBpmnPropertyPanel.vue?vue&type=template&id=3b3156eb&scoped=true"
import script from "./XBpmnPropertyPanel.vue?vue&type=script&lang=js"
export * from "./XBpmnPropertyPanel.vue?vue&type=script&lang=js"
import style0 from "./XBpmnPropertyPanel.vue?vue&type=style&index=0&id=3b3156eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3156eb",
  null
  
)

export default component.exports